import React from "react";

// Avatar component that shows initials only
const MemberAvatar = ({ member, size = "w-10 h-10", textSize = "text-sm" }) => {
  return (
    <div className={`${size} bg-gradient-to-br from-blue-400 to-purple-500 rounded-full flex items-center justify-center`}>
      <span className={`text-white font-semibold ${textSize}`}>
        {member.name.charAt(0).toUpperCase()}
      </span>
    </div>
  );
};

export default MemberAvatar;
